import React, { useEffect, useRef, useState } from "react";
import NotificationListPanel from "../../notifications/NotificationListPanel";
import bellNotificationIcon from "../../../utilities/images/study_dashboard/bell_notification.png";
import "./DashboardNotificationDropdown.css";

const DashboardNotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointerDown = (event) => {
      if (containerRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="dashboard-notification" ref={containerRef}>
      <button
        type="button"
        className={`dashboard-notification__trigger${
          isOpen ? " dashboard-notification__trigger--active" : ""
        }`}
        aria-label="Notifications"
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        onClick={toggleOpen}
      >
        <img
          src={bellNotificationIcon}
          alt=""
          className="dashboard-notification__icon"
          aria-hidden="true"
        />
      </button>

      {isOpen ? (
        <div
          className="dashboard-notification__dropdown"
          role="dialog"
          aria-label="Notifications"
        >
          <NotificationListPanel active={isOpen} heading="Notification" />
        </div>
      ) : null}
    </div>
  );
};

export default DashboardNotificationDropdown;
